import * as React from 'react';
import { useEffect } from 'react';
import { Block } from '../../components/Block';
import { useDispatch, useSelector } from 'react-redux';
import { TThunkDispatch } from '../../types/redux';
import { selectVacancies } from '../../selectors/vacancies';
import { NotFound } from '../../components/NotFound';
import { Vacancies } from './component/vacancies';
import { fetchVacancies } from '../../actions/vacancies/fetchVacancies';
import { resetFilters } from '../../actions/vacancies';
import { sendOpenListingPageEvent } from '../../utils/analytics/events/openListingPage';
import { connectState } from '../../actions/state';
import { LoadingBlock } from '../../components/LoadingBlock';
import { ErrorMessage } from '../../components/ErrorMessage';
import { useDeviceType } from '@cian/ui-kit';
import { Button } from '../../components/Button';

export const VacanciesContainer: React.FC = () => {
  const dispatch = useDispatch<TThunkDispatch>();
  const isDesktop = useDeviceType() === 'desktop';

  const resetSearch = () => {
    dispatch(resetFilters());
    dispatch(fetchVacancies());
  };

  useEffect(() => {
    dispatch(fetchVacancies());
  }, [dispatch]);

  const { vacanciesGroup, isLoading, isError } = useSelector(selectVacancies);

  if (isError) {
    return (
      <Block display="flex" justifyContent="center" marginTop={155} marginBottom={isDesktop ? 95 : 155}>
        <ErrorMessage
          title="Что-то пошло не так"
          description="Обновите страницу"
          controls={
            <Button
              fullWidth
              onClick={() => {
                window.location.reload();
              }}
            >
              Обновить
            </Button>
          }
        />
      </Block>
    );
  }

  if (isLoading || !vacanciesGroup) {
    return (
      <Block display="flex" justifyContent="center" marginTop={198} marginBottom={isDesktop ? 146 : 198}>
        <LoadingBlock />
      </Block>
    );
  }

  dispatch(connectState(sendOpenListingPageEvent({ vacancies: vacanciesGroup })));

  if (!vacanciesGroup.length) {
    return (
      <Block marginTop={106} marginBottom={54}>
        <NotFound handleResetSearch={resetSearch} />
      </Block>
    );
  }

  return <Vacancies groupsJobs={vacanciesGroup} />;
};

VacanciesContainer.displayName = 'VacanciesContainer';
